import { FiscalNumber } from "../fiscal-number";

export class NetworkExternalConfiguration {
  private networkFiscalNumber: string;
  private pricingConsultingEnable: boolean;

  public getNetworkFiscalNumber(): string {
    return this.networkFiscalNumber;
  }

  public setNetworkFiscalNumber(networkFiscalNumber: string): void {
    this.networkFiscalNumber = networkFiscalNumber;
  }

  public isPricingConsultingEnable(): boolean {
    return this.pricingConsultingEnable;
  }

  public setPricingConsultingEnable(pricingConsultingEnable: boolean): void {
    this.pricingConsultingEnable = pricingConsultingEnable;
  }
}
